<template>
    <div :class="show?'opacity-100':'opacity-0'" class="text-white flex-1 col-span-1 border-0 rounded-t-xl transition-opacity duration-1000 ease-in-out">
            <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl">
                <div class="bg-theme-green rounded-t-xl px-4 py-2 text-white">
                    <div class="flex justify-between items-center">
                        <div>
                            <h2 class="font-bold tracking-wider truncate text-single-line leading-tight text-2xl mt-0 mb-4">{{asn?.name ? asn?.name : editItem.name}}</h2>
                            <h3 class="text-sm font-semibold truncate text-single-line leading-tight" v-if="editItem.brand">{{editItem.brand.name}}</h3>
                        </div>
                        <div class="flex flex-col">
                            <button @click="closeEdit" class="mb-3 flex justify-end">
                                CLOSE
                            </button>
                            <div v-if="!disabled" class="mb-1 relative flex justify-end gap-2" tabindex="1" @focusout="focusOutDropDown">
                                <button :disabled="disabledSave" v-if="editPage=='regular'" @click="save" name="save" class="uppercase hover:bg-slate-100 disabled:bg-gray-black px-[14px] py-[10px] bg-white rounded text-sm ml-3 tracking-widest text-theme-green">
                                    save
                                </button>
                                <!-- Drop down -->
                                <div v-if="asn?.id">
                                    <button v-if="editPage!='adjust-inventory'" @click="toggleDropDown" class="uppercase hover:bg-slate-100 px-[14px] py-[10px] bg-white rounded text-sm tracking-widest text-theme-green">...</button>
                                    <div v-if="editDropDown" class="absolute top-14 right-0 mt-1 w-[220px] z-10 rounded-md shadow-lg">
                                        <div class="absolute right-0 -top-4 right-4 h-0 w-0 border-x-8 border-x-transparent border-b-[16px] border-b-gray-black"></div>
                                        <ul role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-item-3" class="bg-gray-black max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                            <template v-for="(eachDropDown, index) in poDropDownList">
                                                <li @click="poDropDownConfirm(eachDropDown.page)" class="cursor-pointer text-white last:text-theme-red hover:bg-light-black select-none relative py-2 pl-3 pr-3">
                                                    <div class="flex items-center">
                                                        <svg v-if="eachDropDown.page=='confirmInventory'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10.6 13.8L8.45 11.65C8.26667 11.4667 8.03333 11.375 7.75 11.375C7.46667 11.375 7.23333 11.4667 7.05 11.65C6.86667 11.8333 6.775 12.0667 6.775 12.35C6.775 12.6333 6.86667 12.8667 7.05 13.05L9.9 15.9C10.1 16.1 10.3333 16.2 10.6 16.2C10.8667 16.2 11.1 16.1 11.3 15.9L16.95 10.25C17.1333 10.0667 17.225 9.83333 17.225 9.55C17.225 9.26667 17.1333 9.03333 16.95 8.85C16.7667 8.66667 16.5333 8.575 16.25 8.575C15.9667 8.575 15.7333 8.66667 15.55 8.85L10.6 13.8ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="white"/>
                                                        </svg>
                                                        <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M9 3V4H4V6H5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V6H20V4H15V3H9ZM7 6H17V19H7V6ZM9 8V17H11V8H9ZM13 8V17H15V8H13Z" fill="#F53333"/>
                                                        </svg>
                                                        <span class="ml-3 block font-normal uppercase" :class="eachDropDown.class">
                                                            {{eachDropDown.name}}
                                                        </span>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                                <div v-else>
                                    <button v-if="editPage!='adjust-inventory'" @click="toggleDropDown" class="uppercase hover:bg-slate-100 px-[14px] py-[10px] bg-white rounded text-sm tracking-widest text-theme-green">...</button>
                                    <div v-if="editDropDown" class="absolute top-14 right-0 mt-1 w-[220px] z-10 rounded-md shadow-lg">
                                        <div class="absolute right-0 -top-4 right-4 h-0 w-0 border-x-8 border-x-transparent border-b-[16px] border-b-gray-black"></div>
                                        <ul role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-item-3" class="bg-gray-black max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                            <template v-for="(eachDropDown, ind) in editDropDownList">
                                                <li v-if="can_edit_product_sale_price_and_inventory || (!can_edit_product_sale_price_and_inventory && eachDropDown.name!=='Adjust inventory')" @click="dropDownConfirm(eachDropDown.page)"  :key="'drop-'+ind" class="cursor-pointer text-white last:text-theme-red hover:bg-light-black select-none relative py-2 pl-3 pr-9">
                                                    <div class="flex items-center">
                                                        <span class="ml-3 block font-normal uppercase" :class="eachDropDown.class">
                                                            {{eachDropDown.name}}
                                                        </span>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-if="editPage!='adjust-inventory'">
                    <ul class="flex gap-[54px] bg-[#2B2C32] rounded-b-xl px-2 pt-3 pb-2">
                        <li @click="toggle('regular')" :class="editPage=='regular'?'active':''">
                            <a class="inline-block text-theme-white  tracking-widest text-sm font-semibold" href="#">GENERAL</a>
                        </li>
                        <li @click="toggle('media')" :class="editPage=='media'?'active':''">
                            <a class="text-theme-dimwhite tracking-widest text-sm font-semibold " :class="disabled?'cursor-not-allowed':'cursor-pointer'" href="#">MEDIA</a>
                        </li>
                        <li @click="toggle('terpene')" :class="editPage=='terpene'?'active':''">
                            <a class="text-theme-dimwhite tracking-widest text-sm font-semibold uppercase" :class="disabled?'cursor-not-allowed':'cursor-pointer'" href="#">Terpenes</a>
                        </li>
                        <li @click="toggle('inventoryLog')" :class="editPage=='inventoryLog'?'active':''">
                            <a class="text-theme-dimwhite tracking-widest text-sm font-semibold uppercase" :class="disabled?'cursor-not-allowed':'cursor-pointer'" href="#">Inventory Log</a>
                        </li>
                    </ul>
                </div>
                <component :disabled="disabled" :productLoading="productLoading" :is="editPage" :asn="asn" :fulfillment="fulfillment" :categories="categories" :brands="brands" :taxes="taxes" :globalExemptScanner="globalExemptScanner" :editItem="productDetail" :cannabisProfile="cannabisProfile" :pricing="pricing" :productTax="productTax" :lotCount="lotCount" @reloadProductDetail="reloadProductDetail" />
            </div> 
    </div>

    <retire v-if="retirePop" :editItem="editItem" @close="closeRetire" />

    <custom-modal :size="'max-w-2xl'" v-if="productCard.modal">
      <template v-slot:maincontent>
        <SelectQrType :isSingle="true" :closeCallBack="closeCallBack" :products="[productCard.product]"/>
      </template>
    </custom-modal>

</template>
<script>
import { ref, defineComponent } from 'vue'
import Helpers from '@/helpers';
import Regular from './Regular.vue'
import Media from './Media.vue'
import InventoryLog from './InventoryLog.vue'
import Terpene from './terpene/Terpene.vue'
import AdjustInventory from './inventory/Inventory.vue'
import Availability from './availability/Availability.vue'
import ProductApi from '@/controllers/BusinessProductApis'
import LocationPosStationApis from '@/controllers/LocationPosStationApis';
import LocationCannabisSettingApi from '@/controllers/LocationCannabisSetting';
import SelectQrType from "@/views/Products/Product/QrCode/Index.vue";
import Retire from './retire/retire.vue'
import {mapGetters, mapMutations} from 'vuex'
import { useSnackbar } from "vue3-snackbar"
import ObjectHelper from '@/helpers/object'

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        asn: {
            type: Object,
        },
        inventory: {
            type: Boolean,
        },
        fulfillment: {
            type: Object,
        },
        editItem: {
            type: Object,
        }
    },
    components: {
        Regular,
        Media,
        InventoryLog,
        Terpene,
        AdjustInventory,
        Availability,
        SelectQrType,
        Retire
    },
    setup() {
        const productLoading = ref(false)
        const show = ref(true)
        const snackbar = useSnackbar();
        const editDropDown = ref(false)
        const productCard = ref({
          modal: false,
          product: {},
        });

        const editDropDownList = [
            {name: 'Adjust inventory', page: 'adjust-inventory', class: ''},
            // {name: 'Merge', page: 'merge', class: ''},
            {name: 'Print product cards', page: 'printProductCard', class: ''},
            // {name: 'Recommendations', page: 'recommendations', class: ''},
            {name: 'Archive / Delete', page: 'delete', class: 'text-theme-red'},
        ]
        const poDropDownList = [
            {name: 'Confirm inventory', page: 'confirmInventory', class: 'text-white'},
            {name: 'Delete', page: 'delete', class: 'text-theme-red'},
        ]
        const globalSetting = ref({})
        const globalExemptScanner = ref({})
        const categories = ref([])
        const brands = ref([])
        const taxes = ref([])
        const productDetail = ref({})
        const cannabisProfile = ref({})
        const pricing = ref({})
        const productTax = ref([])
        const editPage = ref('regular')
        const retirePop = ref(false)
        const lotCount = ref(null)
        const disabledSave = ref(false)

        return {productLoading, show, snackbar, editDropDown, editDropDownList, poDropDownList, globalSetting, globalExemptScanner, categories, brands, taxes, productDetail, editPage, cannabisProfile, pricing, productTax, productCard, retirePop, lotCount, disabledSave}
    },
    mounted(){
        let self = this
        this.vm_spinner(true)
        let promise0 = this.fetchLotSetting()
        let promise1 = this.fetchExemptScannerSetting()
        let promise2 = this.getCategory()
        let promise3 = this.getBrand()
        let promise4 = this.getTaxes()
        let promise5 = this.getProductDetail(this.editItem.parentProductId?this.editItem.parentProductId:this.editItem.id)
        let promise6 = this.getCannabisProfile(this.editItem.parentProductId?this.editItem.parentProductId:this.editItem.id)
        let promise7 = this.getPricing(this.editItem.parentProductId?this.editItem.parentProductId:this.editItem.id)
        let promise8 = this.getProductTax(this.editItem.parentProductId?this.editItem.parentProductId:this.editItem.id)
        Promise.all([promise0, promise1, promise2, promise3, promise4, promise5, promise6, promise7, promise8]).then(() => {
            self.addCurrentCategoryLotTrackingAndGlobalLotTrackingToProductDetailObject()
            self.vm_spinner(false)
        })

        this.emitter.on("added", this.addedFromAsn);
        this.emitter.on("toggleSave", this.toggleSave);
        this.emitter.on("reloadProduct", this.reloadProduct);
        this.emitter.on("showDefaultVariant", this.showDefaultVariant)
        this.emitter.on("changeLotCount", this.changeLotCount)
    },
    beforeDestroy(){
        this.emitter.off("toggleSave", this.toggleSave);
        this.emitter.off("reloadProduct", this.reloadProduct);
        this.emitter.off("showDefaultVariant", this.showDefaultVariant)
        this.emitter.off("changeLotCount", this.changeLotCount)
    },
    unmounted(){
        this.emitter.off("toggleSave", this.toggleSave);
        this.emitter.off("reloadProduct", this.reloadProduct);
        this.emitter.off("showDefaultVariant", this.showDefaultVariant)
        this.emitter.off("changeLotCount", this.changeLotCount)
    },
    watch: {
        'editItem.id'(){
            this.editPage = 'regular'
            let self = this
            this.show = false
            this.vm_spinner(true)
            let promise0 = this.fetchLotSetting()
            let promise1 = this.fetchExemptScannerSetting()
            let promise2 = this.getCategory()
            let promise3 = this.getBrand()
            let promise4 = this.getTaxes()
            let promise5 = this.getProductDetail(this.editItem.parentProductId?this.editItem.parentProductId:this.editItem.id)
            let promise6 = this.getCannabisProfile(this.editItem.parentProductId?this.editItem.parentProductId:this.editItem.id)
            let promise7 = this.getPricing(this.editItem.parentProductId?this.editItem.parentProductId:this.editItem.id)
            let promise8 = this.getProductTax(this.editItem.parentProductId?this.editItem.parentProductId:this.editItem.id)
            Promise.all([promise0, promise1, promise2, promise3, promise4, promise5, promise6, promise7, promise8]).then(() => {
                self.addCurrentCategoryLotTrackingAndGlobalLotTrackingToProductDetailObject()
                self.vm_spinner(false)
                self.show = true
            })
            // this.emitter.on("reloadProduct", this.reloadProduct);
        }
    },
    computed: {
        can_manage_pricing_groups() {
            return Helpers.getMyPermission('can_manage_pricing_groups')
        },
        can_edit_product_sale_price_and_inventory() {
            return Helpers.getMyPermission('can_edit_product_sale_price_and_inventory')
        },
        ...mapGetters({
            vg_selectedBusiness: 'auth/activeBusiness',
            vg_selectedLocation: 'location/selected',
            vg_modified: 'modifiedForm/status'
        })
    },
    methods: {
        addedFromAsn(row){
            this.$emit('added', row)
        },
        toggleDropDown(){
            this.editDropDown = !this.editDropDown
        },
        focusOutDropDown(el){
            if(!el.relatedTarget){
                this.editDropDown = false
            }
        },
        poDropDownConfirm(page){
            if(page=='confirmInventory'){
                this.confirmInventoryItem()
            } else if(page=='delete'){
                this.removeProduct()
            }
        },
        dropDownConfirm(page){
            // show confirm message in product list not in purchase order
            if(this.vg_modified && this.$route.name!=="AddPurchaseOrders"){
                this.confirmNew('Leave?', 'Are you sure you want to leave? Your changes have not been saved','Yes', 'bg-white text-theme-red', 'No', 'bg-theme-green text-white', true).then(async () => {
                    this.vm_modified(false)
                    this.dropDown(page)
                }).catch(err => {
                    console.log(err)
                })
            }else{
                this.dropDown(page)
            }
            this.editDropDown = false
        },
        dropDown(page){
            if(page=='delete'){
                this.retirePop = true
                // this.remove()
            } else if(page == 'adjust-inventory'){
                this.editPage = page
            } else if(page == 'printProductCard'){
                // open mdoal
                this.openProductCardModal()
            } else if(page == 'merge'){
                let obj = ObjectHelper.pickWithDefault(
                    {...this.editItem, ...this.cannabisProfile, ...this.pricing}, 
                    ['name','strain','complianceType','stock_threshold','current_nou','sku','concentration_unit','description','longDescription','thc_cbd_value_type','thc','thc_min','thc_max','cbd','cbd_min','cbd_max','cost','sale_price','batch_lot','packaged_on'],
                    ['', '', '', '', null, '', '', '', 'single', null, null, null, null, null, null, null, null, null, null]
                )
                obj.productId = this.editItem.id
                obj.categoryId = this.editItem.categoryId
                obj.brand_id = this.editItem.brandId
                obj.gtin = this.editItem.barcode
                obj.size = this.editItem.variantName
                obj.weight_equivalent_dry_cannabis = this.editItem.dryCannabisEquivalency
                obj.image = this.editItem.image
                obj.aroma = this.editItem.aroma
                obj.terpene = this.editItem.terpene
                obj.variants = this.productDetail.variants
                let asnObj = {
                    EachGTIN: this.editItem.barcode,
                    ItemName: this.editItem.name,
                    sku: this.editItem.sku,
                    size: this.editItem.variantName,
                    cost: this.pricing.cost,
                    pmdProduct: obj
                }
                this.$emit('toggleAddEdit', {add: true, edit: false, editItem: asnObj, editMerge: true})
            }
        },
        closeEdit(){
            if(this.vg_modified){
                this.confirmNew('Leave?', 'Are you sure you want to leave? Your changes have not been saved','Yes', 'bg-white text-theme-red', 'No', 'bg-theme-green text-white', true).then(async () => {
                    this.vm_modified(false)
                    this.doCloseEdit()
                }).catch(err => {
                    console.log(err)
                })
            }else{
                this.doCloseEdit()
            }
        },
        doCloseEdit(){
            if(this.editPage=='adjust-inventory'){
                this.editPage = 'regular'
            }else{
                this.$emit('close')
            }
        },
        async toggle(name){
            if(this.disabled) return
            // show confirm message in product list not in purchase order
            if(this.vg_modified && this.$route.name!=="AddPurchaseOrders"){
                this.confirmNew('Leave?', 'Are you sure you want to leave? Your changes have not been saved','Yes', 'bg-white text-theme-red', 'No', 'bg-theme-green text-white', true).then(async () => {
                    this.vm_modified(false)
                    this.editPage = name
                }).catch(err => {
                    console.log(err)
                })
            }else{
                this.editPage = name
            }
        },
        save(){
            this.regularPriceEdited = false
            this.emitter.emit('saveEditProduct', true)
        },
        closeRetire(reload){
            
            this.retirePop = false
            if(reload){
                this.$emit('close')
                this.emitter.emit('reloadProductList', true)
            }
        },
        async fetchLotSetting(){
            let res = await LocationCannabisSettingApi.fetchSetting();
            this.globalSetting =  res.status == 200 ? res.data.payload : {lotTracking: false};
        },
        async fetchExemptScannerSetting(){
            let res = await LocationPosStationApis.locationScannerVerification();
            this.globalExemptScanner =  res.status == 200 ? res.data.payload : {enableScannerVerification: false};
        },
        async getCategory(){
            this.categories = []
            let res = await ProductApi.fetchAllCategory()
            if(res.data?.payload?.category){
                for(let i=0; i<res.data.payload.category.length; i++){
                    this.categories.push(res.data.payload.category[i])
                    if(res.data.payload.category[i].subCategories && res.data.payload.category[i].subCategories.length>0){
                        for(let j=0; j<res.data.payload.category[i].subCategories.length; j++){
                            this.categories.push(res.data.payload.category[i].subCategories[j])
                        }
                    }
                }
            }
        },
        async getBrand(){
            let res = await ProductApi.fetchAllBrands()
            if(res.data?.payload?.brands){
                this.brands = res.data.payload.brands
            }
        },
        async getTaxes(){
            if(this.vg_selectedBusiness.id){
                let res = await ProductApi.fetchAllTaxes(this.vg_selectedBusiness.id)
                if(res.data?.payload){
                    this.taxes = res.data.payload
                }
            }
        },
        async getProductDetail(productId){
            if(productId){
                let res = await ProductApi.getProductById(productId, this.vg_selectedLocation.id)
                if(res.data?.payload){
                    this.productDetail = res.data.payload
                    this.productDetail.ppiStock = this.editItem.ppiStock
                }
            }
        },
        async getCannabisProfile(productId){
            if(this.vg_selectedLocation.id){
                let res = await ProductApi.fetchCannabisProfile(productId, this.vg_selectedLocation.id)
                if(res.data?.payload){
                    this.cannabisProfile = res.data.payload
                }else{
                    this.cannabisProfile = {}
                }
            }
        },
        changeLotCount(){
            this.getPricing(this.editItem.parentProductId?this.editItem.parentProductId:this.editItem.id, true)
        },
        async getPricing(productId, updateLotOnly=false){
            if(this.vg_selectedLocation.id){
                let restVariantIds = []
                if(this.editItem?.variants?.length>0){
                    let other = this.editItem.variants.filter(each =>each.id!=productId).map(each => each.id)
                    if(other?.length>0){
                        restVariantIds = other
                    }
                }
                let data = {locationId: this.vg_selectedLocation.id, productIds:[productId, ...restVariantIds]}
                let res = await ProductApi.fetchPricingByProductId(data)
                if(res.data?.payload[0]){
                    if(updateLotOnly){
                        this.lotCount = res.data.payload.map(each=>each.stock).reduce((sum, current) => sum + current, 0);
                    }else{
                        this.pricing = res.data.payload[0]
                        this.lotCount = res.data.payload.map(each=>each.stock).reduce((sum, current) => sum + current, 0);
                    }
                }else{
                    if(updateLotOnly){
                        this.lotCount = 0
                    }else{
                        this.pricing = {}
                        this.lotCount = 0
                    }
                }
            }
        },
        async getProductTax(productId){
            if(this.vg_selectedLocation.id){
                let data = {locationId: this.vg_selectedLocation.id, ProductId:productId}
                let res = await ProductApi.fetchTaxByProductId(data)
                if(res.data?.payload){
                    this.productTax = res.data.payload
                }else{
                    this.productTax = []
                }
            }
        },
        addCurrentCategoryLotTrackingAndGlobalLotTrackingToProductDetailObject(){
            let result = this.categories.find(each => each.id==this.productDetail.categoryId)
            if(result){
                this.productDetail.categoryLotTracking = result.lotTracking
            }
            this.productDetail.globalLotTracking = this.globalSetting.lotTracking
        },
        async reloadProductDetail(productId){
            await this.getProductDetail(productId)
            this.addCurrentCategoryLotTrackingAndGlobalLotTrackingToProductDetailObject()
        },
        toggleSave(value){
            this.disabledSave = value
        },
        reloadProduct(productId){
            console.log("reloadProduct Edit")
            let self = this
            this.productLoading = true
            this.vm_spinner(true)
            let promise1 = this.getProductDetail(productId)
            let promise2 = this.getCannabisProfile(productId)
            let promise3 = this.getPricing(productId)
            Promise.all([promise1, promise2, promise3]).then(() => {
                self.addCurrentCategoryLotTrackingAndGlobalLotTrackingToProductDetailObject()
                setTimeout(function(){
                    self.vm_spinner(false)
                    self.productLoading = false
                }, 700)
            })
        },
        showDefaultVariant(){
            this.editPage = 'regular'
        },
        /**
         * Open Qr Card Modal
         */
        openProductCardModal() {
          this.productCard = {
            modal: true,
            product: this.editItem,
          };
        },
        /**
         * Close Qr Card Modal
         */
        closeCallBack() {
          this.productCard = {
            modal: false,
            product: {},
          };
        },
        async confirmInventoryItem(){
            this.editDropDown = false
            this.confirmNew(null, '<div class="flex items-center font-bold">Are you sure you want to confirm inventory?</div><div class="mt-2">This product will be moved to ‘Confirmed Inventory’, and will be live and sellable. You will have to edit product details from the product list.</div>', 'Continue', null, 'Cancel', null, false, true).then(async () => {
                this.vm_spinner(true)
                let res = await ProductApi.confirmIndividualOrder(this.asn.purchaseOrderId, {"itemIds": [this.asn.id]})
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                })
                if(res.status==200){
                    this.$emit('close')
                    this.emitter.emit('reloadAddAsnList', true)
                }
                this.vm_spinner(false)
            }).catch(err => {
                console.log(err)
            })
        },
        removeProduct(){
            this.editDropDown = false
            this.confirmNew('Remove Product', `Are you sure you want to remove <b>${this.asn.name}</b> from the Purchase Order?`, 'Yes', 'bg-theme-red text-white').then(async () => { 
                this.vm_spinner(true)
                let res = await ProductApi.removePOV2(this.asn.purchaseOrderId, {itemId: this.asn.id})
                if(res.status===200){
                    this.emitter.emit("reloadAddAsnList")
                    this.emitter.emit('closeAddEditInPurchaseOrder')
                }
                this.snackbar.add({
                    type: 'info',
                    text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                    duration: 3000,
                })
                this.vm_spinner(false)
            }).catch(err => {
                console.log(err)
            })
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner',
            vm_modified: 'modifiedForm/mutateStatus'
        })
    }
})
</script>
<style scoped>
    .active{
        /* position:relative; */
        border-bottom: solid 4px #2BA66B;
    }
    /* .active:before {
    content: '';
    position: absolute;
    background: #2BA66B;
    width: 100%;
    height: 4px;
    bottom: -12px;
    } */
  </style>
